// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eea3c38f","239":"9ab5c653","667":"91bf8496"}[chunkId] + ".chunk.js";
};